var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangepassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 215,
    viewBox: "0 0 217 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 142.565,
    cy: 71.9788,
    r: 142.479,
    fill: "url(#paint0_linear_96_4890)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.0371 92.7035V72.2415C88.0371 71.5014 88.3311 70.7917 88.8544 70.2684C89.3776 69.7451 90.0874 69.4512 90.8274 69.4512H146.633C147.373 69.4512 148.083 69.7451 148.606 70.2684C149.129 70.7917 149.423 71.5014 149.423 72.2415V92.7035C149.423 122.007 124.553 131.715 119.587 133.362C119.032 133.553 118.429 133.553 117.874 133.362C112.908 131.715 88.0371 122.007 88.0371 92.7035Z",
    stroke: "white",
    strokeWidth: 5.58057,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.077 88.9834L113.615 108.515L103.384 98.7494",
    stroke: "white",
    strokeWidth: 5.58057,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_4890",
    x1: 261.782,
    y1: -84.9894,
    x2: -67.1727,
    y2: 142.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756318,
    stopColor: "#E35B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepassword);
export default __webpack_public_path__ + "static/media/Change password.3df1d5599cfdef6cb21a8c1c7bb46897.svg";
export { ForwardRef as ReactComponent };